/**
 * Personstamm API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonStammMasterId } from './personStammMasterId';
import { FieldMetaData } from './fieldMetaData';
import { FremdId } from './fremdId';
import { CapiPersonId } from './capiPersonId';
import { PersonStammVersionDetailEntryMeta } from './personStammVersionDetailEntryMeta';
import { PersonAdresseListEntryMeta } from './personAdresseListEntryMeta';


export interface PersonStammMasterDetailEntryMeta { 
    printPDFpossible?: boolean;
    mPrintPDFpossible?: FieldMetaData;
    printRTFpossible?: boolean;
    mPrintRTFpossible?: FieldMetaData;
    version?: PersonStammVersionDetailEntryMeta;
    mVersion?: FieldMetaData;
    adressen?: Array<PersonAdresseListEntryMeta>;
    mAdressen?: FieldMetaData;
    egbpid?: string;
    mEgbpid?: FieldMetaData;
    datenquelle?: string;
    mDatenquelle?: FieldMetaData;
    auskunftsperre?: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum;
    mAuskunftsperre?: FieldMetaData;
    capiPersonId?: CapiPersonId;
    mCapiPersonId?: FieldMetaData;
    masterId: PersonStammMasterId;
    mMasterId?: FieldMetaData;
    kantPersonId?: FremdId;
    mKantPersonId?: FieldMetaData;
}
export namespace PersonStammMasterDetailEntryMeta {
    export type AuskunftsperreEnum = 'AUSKUNFT_SPERRE' | 'ADRESS_SPERRE' | 'KEINE';
    export const AuskunftsperreEnum = {
        AUSKUNFT_SPERRE: 'AUSKUNFT_SPERRE' as AuskunftsperreEnum,
        ADRESS_SPERRE: 'ADRESS_SPERRE' as AuskunftsperreEnum,
        KEINE: 'KEINE' as AuskunftsperreEnum
    };
}


